export const PAGE = 1;
export const LIMIT_PER_PAGE = 25;
export const MAX_LIMIT = 9999;
export const MAX_LIMIT_PER_PAGE = 999999999999999;
